module.exports = __webpack_public_path__ + "static/ground-floor-2e541271f6bb51aa79d59ad274f50560.png";